import React, {Component} from 'react';
import {Button, Loader, Dimmer, Form} from 'semantic-ui-react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {FemaGoModal} from 'app-ui-componentlibrary';
import SubApplicationSearchResultsGrid from 'go/components/application/subApplicationSearchResultsGrid';
import ViewAddedSubApplicationCard from 'go/components/application/viewAddedSubApplicationCard';
import ViewSingleSubapplicationCard from 'go/components/application/viewSingleSubapplicationCard';
import {
  FuzzySearch,
  InlineSelect,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import REST from 'go/requests/rest';
import {getTimestampNowISO} from 'common/utils';
import {SEARCH_DATA_RADIO_BTNS, SEARCH_DATA_RADIO_BTNS_FOR_AMNDMT, SEARCH_DATA_RADIO_BTNS_FOR_AMNDMT_WITH_EXISTING, SEARCH_DATA_RADIO_BTNS_FOR_AMNDMT_DISABLED} from './constants';
import { 
  STATUS_SUBAWARD_ACCEPTED, STATUS_SUBMITTED_TO_FEMA,
} from 'app-ui-componentlibrary/dist/common/constants';

const MODAL_OPTIONS = {
  CREATE: 'create',
  NONE: 'none',
  SUCCESS: 'success',
};

const SEARCH_OPTIONS = {
  INITIAL: 'start',
  IN_PROGRESS: 'inprogress',
  SUCCESS: 'success',
  ERROR: 'error',
  DEFAULT: 'title',
};

const SEARCH_OPTIONS_AMENDMENT_OVERRIDE = {
  DEFAULT: 'subgrant'
}

export class AddSubApplicationContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      subAppAlreadyLinked: false,
      openModal: MODAL_OPTIONS.NONE,
      searchOption: undefined,
      searchData: [],
      searchValue: '',
      searchClear: false,
      rankingType: '',
      results: [],
      programId: this.props.programId,
      selectedSubApp: '',
      showError: false,
      errorToShow: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.programId, this.props.programId)) {
      this.setState({
        programId: this.props.programId,
      });
    }
  }

  addSubApplicationHandler = () => {
    const disableNewSubAppAmendments = _.includes(this.props.toggles, `disableNewSubAppAmendments`);
    this.setState((prevState) => ({
      ...prevState,
      showSuccessWindow: false,
      subAppAlreadyLinked: false,
      data: undefined,
      searchOption: this.props.isAddingToAmendment &&  disableNewSubAppAmendments ? SEARCH_OPTIONS_AMENDMENT_OVERRIDE.DEFAULT : SEARCH_OPTIONS.DEFAULT,
      searching: SEARCH_OPTIONS.INITIAL,
      openModal: MODAL_OPTIONS.CREATE,
    }));
  };

  handleSearchOptionChange = (event, {value}) => {
    this.setState((prevState) => ({
      ...prevState,
      searchOption: value,
      searchValue: '',
      searching: SEARCH_OPTIONS.INITIAL,
      selectedSubApp: '',
      showError: false,
      errorToShow: null
    }));
  };

  handleCategoryTypeChange = (e) => {
    const {value} = e.target;
    this.setState({
      categoryType: value,
      loading: false,
    });
  };

  resetSearchClear = () => {
    this.setState({searchClear: false});
  };

  mapESearchToObj = (entity, prefixTitle) => {
    const costShareDollar = _.get(entity, 'payload.budget.share.fedShare', 0);
    const title = `${prefixTitle ? `${prefixTitle}: ` : ''}${entity.payload.applicationTitle}`;
    return {
      entityId: entity.entityId,
      title,
      applicationType: entity.payload.applicationType,
      applicationTitle: entity.payload.applicationTitle,
      subOrgId: entity.subOrgId,
      federalCostShareDollar: costShareDollar,
      subGrantId: entity.subGrantId
    };
  };

  getSubAppsByTitle = async (value) => {
    let res = {};
    const {programId} = this.state;
    this.setState({loading: true});

    try {
      res = await REST.search.getSubAppsByTitle(
        this.props.token,
        this.props.organizationId,
        programId,
        this.props.allowedSubAppTypes,
        this.props.entityId,
        value
      );

      return res.json();
    } catch (error) {
      this.setState({
        loading: false,
      });
      if (error) {
        this.setState({error: true});
      }
    }
  };

  getSubGrantsByID = async (value) => {
    let res = {};
    this.setState({loading: true});
    const activeExistingSubGrantList = _.get(this.props.context, 'workflowTask.processVariables.activeExistingSubGrantList');

    try {
      res = await REST.dynamicData.getAllByGrantIdAndEntityType(
        this.props.token,
        this.props.grantId,
        'subGrant'
      );

      return res.json().then((response) => {
        const formattedResponse = { items: _.filter(response, subGrant => {
          return subGrant.status === STATUS_SUBAWARD_ACCEPTED 
                && _.includes(subGrant.entityId, value)
                && !_.includes(activeExistingSubGrantList, subGrant.entityId)
        }) };
        return formattedResponse;
      });
    } catch (error) {
      this.setState({
        loading: false,
      });
      if (error) {
        this.setState({error: true});
      }
    }
  };

  performSearch = async (value) => {
    let searchData = [];
    if (value.length < 1) return [];

    const re = new RegExp(_.escapeRegExp(value), 'i');
    const isMatch = (result) => {
      return re.test(result);
    };

    this.setState({
      subAppAlreadyLinked: false,
    });

    if (this.state.searchOption === 'subapplicant') {
      let newArray = [];
      this.props.subOrgs.forEach((val, key) => {
        if (isMatch(val)) {
          newArray.push({entityId: key, title: val});
        }
      });
      return newArray;
    } else if (this.state.searchOption === 'type') {
      const mapToObj = (type) => {
        if (type.code !== '5P')
          return {code: type.code, title: type.description, entityId: type.id};
        else return {code: '', title: '', entityId: ''};
      };
      searchData = _.map(this.props.applicationTypes, mapToObj);
      return _.filter(searchData, (o) => isMatch(o.title));
    } else if (this.state.searchOption === 'title') {
      let filteredData = this.getSubAppsByTitle(value).then((subAppsObj) => {
        return _.map(subAppsObj.items, entity => this.mapESearchToObj(entity));
      });
      return filteredData;
    } else if (this.state.searchOption === 'subgrant') {
      let filteredData = this.getSubGrantsByID(value).then((subAppsObj) => {
        return _.map(subAppsObj.items, entity => this.mapESearchToObj(entity, entity.subGrantId));
      });
      return filteredData;
    }
  };

  searchAgain = (event) => {
    const disableNewSubAppAmendments = _.includes(this.props.toggles, `disableNewSubAppAmendments`);
    event.preventDefault();
    this.setState((prevState) => ({
      ...prevState,
      searching: SEARCH_OPTIONS.INITIAL,
      searchOption: this.props.isAddingToAmendment && disableNewSubAppAmendments ? SEARCH_OPTIONS_AMENDMENT_OVERRIDE.DEFAULT : SEARCH_OPTIONS.DEFAULT,
      searchClear: true,
      showSuccessWindow: false,
      categoryType: '',
    }));
  };

  showResultsView = (event) => {
    event.preventDefault();
    this.setState({
      showSuccessWindow: false,
      searching: SEARCH_OPTIONS.IN_PROGRESS,
    });
    const {searchOption, searchValue} = this.state;
    if (searchOption === 'subapplicant') {
      this.getApplicantsBySubOrgId(searchValue.organizationId);
    } else if (searchOption === 'type') {
      this.getSubAppsByType(searchValue.id);
    } else if (searchOption === 'title' || searchOption === 'subgrant') {
      this.setState({
        searching: SEARCH_OPTIONS.SUCCESS,
        data: {},
      });
    }
  };

  handleSubApplicationSelectionChangeRadio = (e) => {
    const {value} = e.target;

    this.setState((prevState) => ({
      ...prevState,
      selectedSubApp: value,
    }));
  };
  handleSubApplicationSelectionChange = (value) => {
    let data = this.state.data;
    _.forEach(data, (subApplication) => {
      if (subApplication.entityId === value) {
        subApplication.checked = !subApplication.checked;
      }
    });
    this.setState((prevState) => ({
      ...prevState,
      data: data,
    }));
  };

  handleAddSingleSubApplication = () => {
    this.setState(
      {
        loading: true,
        subAppAlreadyLinked: false,
      },
      () => {
        const subApplicationCategory = _.get(this.state, 'categoryType');
        const applicationLinkItems = this.getApplicationLinksBySubApps(
          `"${this.state.data.entityId.trim()}"`
        );
        applicationLinkItems.then((response) => {
          if (!_.isEmpty(response)) {
            this.setState({
              subAppAlreadyLinked: true,
            });
          } else if (!_.isEmpty(subApplicationCategory)) {
            this.saveBulkApplicationLinkEntities(
              [this.state.data.entityId],
              subApplicationCategory
            ).then(() => {
              this.setState({
                showSuccessWindow: true,
                categoryType: '',
                loading: false,
                subAppAlreadyLinked: false,
              });
            });
          }
        });
      }
    );
  };

  handleAddSubApplicationToAmendment = async () => {
    this.setState({
      addingSubApp: true,
      errorToShow: null
    });
    let data = this.state.data;

    const subApplicationId = this.state.selectedSubApp
      ? this.state.selectedSubApp
      : data.entityId;
    const amendmentId = this.props.context.amendment.entityId;
    const grantId = this.props.grantId;
    const { subGrantId } = this.state.data;

    if (this.state.selectedSubApp) {
      data = _.filter(data, (subApp) => {
        return subApp.entityId === this.state.selectedSubApp;
      });
    }

    let matchingPayments = 0;

    if (subGrantId) {
      const payments = await REST.dynamicData.getAllByGrantIdAndEntityType(this.props.token, grantId, 'payment')
        .then(REST.handler.handleResponse)
      
      if (payments.length){
        matchingPayments = _.filter(payments, payment => payment.subGrantId === subGrantId && payment.status === STATUS_SUBMITTED_TO_FEMA).length;
      }
    }

    if (matchingPayments > 0){
      this.setState({
        showSuccessWindow: false,
        showError: true,
        errorToShow: 'You cannot add this subgrant as part of this amendment because there is an existing payment that is submitted to FEMA.',
        categoryType: '',
        loading: false,
        subAppAlreadyLinked: false,
        addingSubApp: false,
      });
    } else {
      this.saveApplicationToAmendment(subApplicationId, amendmentId, grantId, subGrantId)
        .then(() => {
          const activeAdditionList = _.get(this.props, 'context.workflowTask.processVariables.activeAdditionList', []);
          this.props.saveEntitySessionData('context.workflowTask.processVariables.activeAdditionList', [...activeAdditionList, subApplicationId]);
          this.setState((previousState) => ({
            ...previousState,
            showSuccessWindow: true,
            data: data,
            subAppAlreadyLinked: false,
            addingSubApp: false,
          }));
        })
        .catch((e) => {
          this.setState({
            showSuccessWindow: false,
            showError: true,
            categoryType: '',
            loading: false,
            subAppAlreadyLinked: false,
            addingSubApp: false,
          });
        });
    }
  };

  handleAddSubApplication = () => {
    let data = _.filter(this.state.data, (application) => application.checked);
    const subApplicationIds = _.map(data, 'entityId');
    const subApplicationCategory = _.get(this.state, 'categoryType');
    const applicationLinkItems = this.getApplicationLinksBySubApps(
      _.chain(subApplicationIds)
        .map((subApp) => `"${subApp}"`)
        .join(',')
    );
    applicationLinkItems.then((response) => {
      if (!_.isEmpty(response)) {
        this.setState({
          subAppAlreadyLinked: true,
        });
      } else if (!_.isEmpty(subApplicationCategory)) {
        this.saveBulkApplicationLinkEntities(
          subApplicationIds,
          subApplicationCategory
        ).then(() => {
          this.setState({
            showSuccessWindow: true,
            data: data,
            categoryType: '',
            subAppAlreadyLinked: false,
          });
        });
      }
    });
  };

  saveEntity = async (service, action, params) => {
    try {
      let response = await REST[service][action](...params);
      return response.json().then((data) => {
        REST.dynamicData
          .getEntityById(this.props.token, this.props.entityId)
          .then(REST.handler.handleResponse)
          .then((entity) => {
            this.props.saveEntitySessionData('data', entity);
            this.setState({
              loading: false,
            });
          });
      });
    } catch (error) {
      this.setState({
        loading: false,
      });
      if (error) {
        this.setState({error: true});
      }
    }
  };
  saveApplicationToAmendment = async (subApplicationId, amendmentId, grantId, subGrantId) => {
    this.setState({loading: true});
    const activityId = 'subApplicationAddedCatchMsg';
    const service = 'workflow';
    const action = 'sendMessage';
    let variables = {subApplicationId: subApplicationId, grantId: grantId, isExistingSubGrantId: false};
    if (subGrantId) {
      variables = { ...variables, existingSubGrantId: subGrantId, isExistingSubGrantId: true };
    }
    const payloadToSend = {
      workflowMessageName: `${amendmentId}-subapplication-added`,
      variables,
    };
    const params = [activityId, payloadToSend];

    return this.saveEntity(service, action, params);
  };

  saveBulkApplicationLinkEntities = async (subApplicationIds, subApplicationCategory) => {
    this.setState({loading: true});
    const currentDate = getTimestampNowISO();
    const service = 'dynamicData';
    const action = 'updateApplicationLinkEntities';
    const payloadToSend = {
      entityType: this.props.entityType ? this.props.entityType : 'applicationLink',
      fundingOpportunityId: this.props.fundingOpportunityId,
      programId: this.state.programId,
      organizationId: this.props.organizationId,
      grantId: this.props.grantId,
      status: 'pendingSubmission',
      statusDate: currentDate,
      statusTimestamp: currentDate,
      applicationId: this.props.entityId,
      subApplicationIds: subApplicationIds,
      subApplicationCategory: subApplicationCategory,
    };

    const params = [this.props.token, payloadToSend];

    return this.saveEntity(service, action, params);
  };

  handleResultSelect = (result) => {
    this.setState({
      searchValue: result,
      searching: SEARCH_OPTIONS.IN_PROGRESS,
    });
    if (this.state.searchOption === 'subapplicant') {
      this.getApplicantsBySubOrgId(result.entityId);
    } else if (this.state.searchOption === 'type') {
      this.getSubAppsByType(result.entityId);
    } else if (this.state.searchOption === 'title' || this.state.searchOption === 'subgrant') {
      let subApplicantTitle = this.props.subOrgs.get(parseInt(result.subOrgId, 10));
      this.setState((prevState, props) => {
        return {
          searching: SEARCH_OPTIONS.SUCCESS,
          data: {...result, subApplicantTitle: subApplicantTitle},
        };
      });
    }
  };

  closeModal = () => {
    const {showSuccessWindow: success} = this.state;
    this.setState({
      openModal: MODAL_OPTIONS.NONE,
      categoryType: '',
    });
    this.props.reloadLinks(success);
  };

  getApplicationLinksBySubApps = (value) => {
    return new Promise((resolve, reject) => {
      REST.search
        .getApplicationLinkBySubApps(
          this.props.token,
          this.props.organizationId,
          this.props.entityType,
          value
        )
        .then(REST.handler.handleResponse)
        .then((response) => {
          resolve(response.items);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  getSubAppsByType = async (applicantType) => {
    const {programId} = this.state;
    let response = {};
    let resJson = {};
    try {
      response = await REST.search.getSubAppsByType(
        this.props.token,
        this.props.organizationId,
        programId,
        this.props.allowedSubAppTypes,
        this.props.entityId,
        applicantType
      );
      resJson = await response.json();

      let convertResJson = await this.convertToSearchView(
        this.props.entityId,
        resJson.items
      );

      await this.setState({
        searching: SEARCH_OPTIONS.SUCCESS,
        data: convertResJson,
        subApplications: _.cloneDeep(resJson.items),
      });
    } catch (error) {
      this.setState({
        searching: SEARCH_OPTIONS.ERROR,
        data: [],
      });
    }
  };

  getApplicantsBySubOrgId = async (subOrgId) => {
    const {programId} = this.state;
    let response = {};
    let resJson = {};

    try {
      response = await REST.search.getSubAppsBySubapplicant(
        this.props.token,
        this.props.organizationId,
        programId,
        this.props.allowedSubAppTypes,
        this.props.entityId,
        subOrgId
      );
      resJson = await response.json();

      let convertResJson = await this.convertToSearchView(
        this.props.entityId,
        resJson.items
      );
      await this.setState({
        searching: SEARCH_OPTIONS.SUCCESS,
        data: convertResJson,
        subApplications: _.cloneDeep(resJson.items),
      });
    } catch (error) {
      this.setState({
        searching: SEARCH_OPTIONS.ERROR,
        data: [],
      });
    }
  };

  convertToSearchView = (applicationEntityId, data) => {
    const isAllreadyAssociated = (subApplication) => {
      return (
        subApplication.payload &&
        subApplication.payload.applicationType &&
        !(
          subApplication.payload.parentApplicationIds &&
          _.indexOf(subApplication.payload.parentApplicationIds, applicationEntityId) >= 0
        )
      );
    };

    const mapToObj = (subApplication) => {
      let costShareDollar = _.get(subApplication, 'payload.budget.share.fedShare', 0);

      return {
        entityId: subApplication.entityId,
        applicationTitle: subApplication.payload.applicationTitle,
        applicationType: subApplication.payload.applicationType,
        subOrgId: subApplication.subOrgId,
        subApplicantTitle: this.props.subOrgs.get(parseInt(subApplication.subOrgId, 10)),
        federalCostShareDollar: costShareDollar,
      };
    };
    const filteredData = _.map(_.filter(data, isAllreadyAssociated), mapToObj);
    return filteredData;
  };

  getApplicationTypeLabel = (id) => {
    return _.result(
      _.find(this.props.applicationTypes, function (obj) {
        return obj.id === parseInt(id, 10);
      }),
      'description'
    );
  };

  showModal = () => {
    const {options, categoryLabel, isAddingToAmendment, toggles, fundingOpportunityId} = this.props;    
    const disableNewSubAppAmendments = _.includes(toggles, `disableNewSubAppAmendments`);
    const categorySelect = (
      <InlineSelect
        options={options}
        name="categoryType"
        label={categoryLabel}
        value={this.state.categoryType}
        size="small"
        handleChange={this.handleCategoryTypeChange}
      />
    );
    return (
      <FemaGoModal
        type="alert"
        size="small"
        title={isAddingToAmendment ?  'Add subamendment' : 'Add subapplication(s)'}
        className="modal-title"
        open={this.state.openModal === MODAL_OPTIONS.CREATE}
        confirmButton="hidden"
        confirmAction={() => {}}
        cancelAction={this.closeModal}
      >
        <Form id="add-subapplication-search">
          <span className="modal-instructions">
            <small>
              <b>Search for the subapplication or subgrant you wish to amend</b>
            </small>
            <br />
            {isAddingToAmendment
              ? 'You can add a subapplication as a subamendment by searching for a subapplication title or type.'               
              : 'You can add a subapplication by searching for a subapplication title, type or subapplicant.'}
              { <span><br />You can add a subgrant as a subamendment by searching for a subgrant ID that has been awarded.</span> }
          </span>
          <br />
          <br />
          <FuzzySearch
            title="Search"
            name="addSubApplication"
            radioBtns={
              isAddingToAmendment
                ? disableNewSubAppAmendments ? SEARCH_DATA_RADIO_BTNS_FOR_AMNDMT_DISABLED : SEARCH_DATA_RADIO_BTNS_FOR_AMNDMT_WITH_EXISTING                
                : SEARCH_DATA_RADIO_BTNS
            }
            numColumns={4}
            searchWidth={5}
            radioSelectedValue={this.state.searchOption}
            handleRadioSelection={this.handleSearchOptionChange}
            performSearch={this.performSearch}
            searchClear={this.state.searchClear}
            resetSearchClear={this.resetSearchClear}
            handleResultSelect={this.handleResultSelect}
            clearAllFilters={this.searchAgain}
          />

          {this.state.searching === SEARCH_OPTIONS.IN_PROGRESS && (
            <Dimmer active inverted>
              <Loader inverted />
            </Dimmer>
          )}
          {this.state.searching === SEARCH_OPTIONS.SUCCESS &&
            (this.state.searchOption === 'title' || this.state.searchOption === 'subgrant' ? (
              <>
                <ViewSingleSubapplicationCard
                  data={this.state.data}
                  categorySelect={categoryLabel ? categorySelect : null}
                  categoryType={categoryLabel ? this.state.categoryType : null}
                  resetCategoryType={categoryLabel ? this.resetCategoryType : null}
                  getApplicationTypeLabel={this.getApplicationTypeLabel}
                  searchAgain={this.searchAgain}
                  handleChange={this.handleSubApplicationSelectionChange}
                  handleAddSingleSubApplication={
                    isAddingToAmendment
                      ? this.handleAddSubApplicationToAmendment
                      : this.handleAddSingleSubApplication
                  }
                  subAppAlreadyLinked={this.state.subAppAlreadyLinked}
                  loading={this.state.loading}
                  isAddingToAmendment={isAddingToAmendment}                  
                  searchOption={this.state.searchOption}
                  showError={this.state.showError}
                  errorToShow={this.state.errorToShow}
                  addingSubApp={this.state.addingSubApp}
                />
              </>
            ) : (
              <SubApplicationSearchResultsGrid
                data={this.state.data}
                categorySelect={categoryLabel ? categorySelect : null}
                categoryType={categoryLabel ? this.state.categoryType : null}
                getApplicationTypeLabel={this.getApplicationTypeLabel}
                searchAgain={this.searchAgain}
                handleChange={
                  isAddingToAmendment
                    ? this.handleSubApplicationSelectionChangeRadio
                    : this.handleSubApplicationSelectionChange
                }
                handleAddSubApplication={
                  isAddingToAmendment
                    ? this.handleAddSubApplicationToAmendment
                    : this.handleAddSubApplication
                }
                subAppAlreadyLinked={this.state.subAppAlreadyLinked}
                selectedSubApp={this.state.selectedSubApp}
                loading={this.state.loading}
                isAddingToAmendment={isAddingToAmendment}              
                showError={this.state.showError}
                addingSubApp={this.state.addingSubApp}
              />
            ))}
        </Form>
      </FemaGoModal>
    );
  };

  showSuccessModal = () => {
    const { isAddingToAmendment, toggles, fundingOpportunityId } = this.props;   
    return (
      <FemaGoModal
        type="alert"
        size="medium"
        title={isAddingToAmendment ?  "Subamendment is being added:" : "Subapplication(s) successfully added:"}
        className="modal-title"
        open={this.state.openModal === MODAL_OPTIONS.CREATE}
        confirmButton="hidden"
        confirmAction={() => {}}
        cancelAction={this.closeModal}
      >
        <ViewAddedSubApplicationCard
          data={this.state.data}
          closeModal={this.closeModal}
          singleApplication={this.state.searchOption === 'title' || this.state.searchOption === 'subgrant'}
          searchOption={this.state.searchOption}
          showResultsView={this.showResultsView}
          isAddingToAmendment={isAddingToAmendment}
        />
      </FemaGoModal>
    );
  };

  render() {
    const { toggles, fundingOpportunityId, isAddingToAmendment } = this.props;   
    return (
      <React.Fragment>
        <Button
          id="addSubApplication"
          primary
          onClick={(e) => this.addSubApplicationHandler(e)}
        >
          {' '}
          {isAddingToAmendment
            ?  '+ Add subamendment'            
            : `+ Add subapplication(s)`}
        </Button>
        {this.state.showSuccessWindow ? this.showSuccessModal() : this.showModal()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    auth: state.auth,
    organizationId: _.get(state.dynamicComponent.data, 'organizationId'),
    fundingOpportunityId: _.get(state.dynamicComponent.data, 'fundingOpportunityId', _.get(state.dynamicComponent.context, 'grant.fundingOpportunityId')),
    entityId: _.get(state.dynamicComponent.data, 'entityId'),
    grantId: _.get(state.dynamicComponent.data, 'grantId'),
    applicationTypes: _.get(
      state,
      'dynamicComponent.context.loadRefApplicantType.APPLICATION_TYPE',
      null
    ),
    toggles: state.toggles.toggles
  };
};

export default connect(mapStateToProps, null)(connectDynamic(AddSubApplicationContainer));